import React from 'react';
import { IoRocketSharp, IoStatsChart } from "react-icons/io5";
import demoUnbot from 'assets/images/demo-unbot.gif';
import './LandingHero.css';

const LandingHero = ({ onRegisterButtonClicked }) => {
    return (
        <section className="landing-hero">
            <div className="hero-background-glow"></div>
            <div className="landing-section hero-content">
                <h1 className="hero-title animate-fade-in-up">
                    <span className="gradient-text">Boost tes revenus</span><br />
                    sur Uncove.
                </h1>
                <p className="hero-subtitle animate-fade-in-up" style={{ animationDelay: '0.2s' }}>
                    Unbot répond à tes DMs, vend tes médias 24/7.
                    <br />L'IA la plus avancée pour automatiser ton compte.
                </p>

                <div className="hero-cta-group animate-fade-in-up" style={{ animationDelay: '0.4s' }}>
                    <button className="btn-primary-glow" onClick={onRegisterButtonClicked}>
                        Commencer gratuitement
                    </button>
                    <button className="btn-secondary-glass" onClick={() => window.open('https://calendly.com/estrades-thyms86/30min', '_blank')}>
                        Réserver une démo
                    </button>
                </div>

                <div className="hero-visual animate-fade-in-up" style={{ animationDelay: '0.6s' }}>
                    {/* Abstract Dashboard or App Preview */}
                    <div className="glass-card-preview">
                        <div className="stat-floating float-1">
                            <span className="icon-wrapper primary"><IoStatsChart /></span>
                            <div>
                                <span className="label">Ventes du jour</span>
                                <span className="value">+ 128%</span>
                            </div>
                        </div>
                        <div className="stat-floating float-2">
                            <span className="icon-wrapper accent"><IoRocketSharp /></span>
                            <div>
                                <span className="label">Taux de réponse</span>
                                <span className="value">100%</span>
                            </div>
                        </div>
                        <img
                            src={demoUnbot}
                            alt="Unbot Interface"
                            className="hero-dashboard-img"
                        />
                    </div>
                </div>
            </div>
        </section>
    );
};

export default LandingHero;
